import { useMutation } from '@apollo/client'
import {
  CreateStepDocument,
  CreateStepMutationVariables,
  GetProcessDetailDocument,
} from 'generated/resources/graphql'

export const useCreateStep = () => {
  const [executeMutation] = useMutation(CreateStepDocument)

  const createStep = async (variables: CreateStepMutationVariables) => {
    const { data, errors } = await executeMutation({
      variables,
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GetProcessDetailDocument,
          variables: {
            id: variables.processId,
          },
        },
      ],
    })

    if (errors?.length || data?.processesMutations?.createProcessesStep?.errors.length) {
      throw (
        'Could not create step: ' +
        JSON.stringify([
          ...(errors || []),
          ...(data?.processesMutations?.createProcessesStep?.errors || []),
        ])
      )
    }
  }

  return {
    createStep,
  }
}
